import React from "react";
import {Route} from "react-router-dom";
import AddPositionLoanable from "../../pages/ptm/captureLoanableValues/addPostitionLoanable";
import EditPositionLoanable from "../../pages/ptm/captureLoanableValues/editPostitionLoanable";

import {ADD_POSITION_LOANABLE_ROUTE, EDIT_POSITION_LOANABLE_ROUTE} from "../../utils/constants/RoutesConstants";

const CaptureLoanableRoutes = () => {
    return (
        <React.Fragment>
            <Route path={ADD_POSITION_LOANABLE_ROUTE} component={AddPositionLoanable}/>
            <Route path={EDIT_POSITION_LOANABLE_ROUTE} component={EditPositionLoanable}/>
        </React.Fragment>
    );
};

export default CaptureLoanableRoutes;